import Types from './../constants/cities';
import LiService from '../services/li.service';
import OfficeService from '../services/offices.service';
import GroupsService from '../services/groups.service';
import history from './../history';
import { openRequestModal } from './modals';
import i18n from 'i18next';

export function getAllCities(args) {
  return async (dispatch, getState) => {
    let router = getState().router.location.pathname;
    let routerCity = '';
    if (router.split('/').length === 2) {
      routerCity = router.split('/')[1];
      if (!routerCity) {
        openRequestModal({
          opened: true,
          data: {
            header: i18n.t('form.choose_city'),
            modaltype: 'ChooseCity',
          },
        })(dispatch, getState);
      }
    }
    const res = await LiService.GetAllCities();
    let defaultCity = res
      ? res.find((el) => el.program_title === routerCity)
      : null;
    if (!defaultCity) {
      defaultCity = await LiService.GetDefaultCity();
      routerCity = '';
    }

    const officeId = res
      ? res.find((el) => el.program_title === defaultCity.program_title)
      : null;
    if (
      defaultCity &&
      defaultCity.phones.length === 1 &&
      defaultCity.phones[0].includes(',')
    ) {
      defaultCity.phones = defaultCity.phones[0].split(',').filter(Boolean);
    }
    const offices = officeId
      ? await OfficeService.GetCityOffices(officeId.id)
      : null;
    const newOffices = processOnlineOffice(offices);

    dispatch({
      type: Types.DATA,
      cities: {
        list: JSON.stringify(res),
        defaultCity,
        offices: newOffices,
      },
    });
    if (!routerCity) {
      history.push(`/${defaultCity.program_title}`);
    }
  };
}
function isOfficeOnline(office) {
  return (
    office.office_address.ua.toLocaleLowerCase() === 'онлайн' ||
    office.office_address.ru.toLocaleLowerCase() === 'онлайн' ||
    office._id === 'ONLINE'
  );
}

function processOnlineOffice(offices) {
  if (!offices) {
    return [];
  }
  const newOffices = JSON.parse(JSON.stringify(offices));
  const isOnlineOfficeExist = newOffices.some((office) => {
    return (
      office.office_address.ua.toLocaleLowerCase() === 'онлайн' ||
      office.office_address.ru.toLocaleLowerCase() === 'онлайн'
    );
  });
  if (isOnlineOfficeExist) {
    return newOffices;
  }

  if (!isOnlineOfficeExist) {
    newOffices.push({
      _id: 'ONLINE',
      title: {
        ru: 'Онлайн',
        ua: 'Онлайн',
        en: 'Online',
        it: 'Online',
        pl: 'Online',
        by: 'Online',
        md: 'Online',
        cz: 'Online',
      },
      office_address: {
        ru: 'Онлайн',
        ua: 'Онлайн',
        en: 'Online',
        it: 'Online',
        pl: 'Online',
        by: 'Online',
        md: 'Online',
        cz: 'Online',
      },
    });
    return newOffices;
  }
}

export function SetCity(item) {
  return async (dispatch, getState) => {
    // if (!item) {
    //   const list = JSON.parse(getState().cities.list);
    //   item = list.find((el) => el.program_title === "dnepr");
    // }
    dispatch({
      type: Types.DATA,
      cities: {
        selectedOffice: null,
        selectedGroup: null,
        offices: null,
        groups: null,
      },
    });
    if (item && item.phones.length === 1 && item.phones[0].includes(',')) {
      item.phones = item.phones[0].split(',').filter(Boolean);
    }
    const offices = !item ? null : await OfficeService.GetCityOffices(item.id);
    const newOffices = processOnlineOffice(offices);
    console.log('newOffices', newOffices);
    dispatch({
      type: Types.DATA,
      cities: {
        defaultCity: item,
        // selectedCity: item,
        offices: newOffices,
      },
    });
    history.push(`/${item ? item.program_title : ''}`);
  };
}

export function SetOffice(selectedOffice) {
  return async (dispatch, getState) => {
    const {
      cities: {
        defaultCity: { id },
      },
    } = getState();
    dispatch({
      type: Types.DATA,
      cities: {
        ...getState().cities,
        groups: null,
        selectedGroup: null,
      },
    });
    if (!selectedOffice) {
      return;
    }
    if (isOfficeOnline(selectedOffice)) {
      const groups = await GroupsService.GetOnlineGroups(id);
      dispatch({
        type: Types.DATA,
        cities: {
          ...getState().cities,
          selectedOffice,
          groups: groups.filter((el) => el.course_type === '3'),
        },
      });
      return;
    }
    let groups = await GroupsService.GetCityGroups(selectedOffice._id);

    dispatch({
      type: Types.DATA,
      cities: {
        ...getState().cities,
        selectedOffice,
        groups: groups.filter((el) => el.course_type === '3'),
      },
    });
  };
}

export function SetGroup(selectedGroup) {
  return async (dispatch, getState) => {
    dispatch({
      type: Types.DATA,
      cities: {
        ...getState().cities,
        selectedGroup,
      },
    });
  };
}
